import { FlexBox, marginEdgesRules, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { useClub } from 'app/clubs/hooks'
import { isPremiumClub } from 'app/clubs/utils'
import { ClubImage, MemberCount, PremiumClubTag } from 'components'
import { useTimeAgo } from 'hooks'

export const ClubDetailHeader = () => {
  const club = useClub()
  const { colors, mediaQueries } = useTheme()
  const time = useTimeAgo({ date: club?.last_update as string })
  const premium = isPremiumClub(club)

  return (
    <div
      className={css`
        padding: 30px ${marginEdgesRules.mobile} 0;
        width: 100%;
        ${mediaQueries.mobileS} {
          padding: 30px 0 0;
        }
        ${mediaQueries.tabletL} {
          padding-top: 54px;
          margin-bottom: 0;
          max-width: 352px;
          position: sticky;
          top: 100px;
          align-self: flex-start;
        }
      `}
    >
      {premium ? (
        <PremiumClubTag
          className={css`
            margin-bottom: 12px;
            ${mediaQueries.tabletL} {
              margin: 0 auto 12px;
            }
          `}
          colors={{ background: colors.pewterGrey }}
        />
      ) : null}
      <Text
        className={css`
          ${mediaQueries.tabletL} {
            text-align: center;
          }
        `}
        type="header"
        sizing={{ base: 'M', tabletL: 'L' }}
        text={club?.title as string}
        color={colors.graphite}
      />
      <FlexBox
        className={css`
          margin: 12px 0;
        `}
        justifyContent="space-between"
        alignItems="center"
      >
        <Text type="label" sizing="L" color={colors.uiPewterGreyLight}>
          Last updated {time}
        </Text>
        <MemberCount
          count={club?.member_count as number}
          color={colors.uiPewterGreyLight}
        />
      </FlexBox>
      <ClubImage
        className={css`
          border-radius: 16px;
          height: 80vw;
          ${mediaQueries.mobileS} {
            height: 307px;
          }
        `}
        club={club}
        hero
      />
    </div>
  )
}
